import * as actions from 'actions';

const INITIAL_STATE = {
  isInputVisible: false,
  goalText: ''
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case actions.GOAL_ADDING_SHOW: {
      return {
        ...state,
        isInputVisible: true
      };
    }

    case actions.GOAL_ADDING_HIDE: {
      return {
        ...state,
        goalText: '',
        isInputVisible: false
      };
    }

    case actions.GOAL_ADDING_UPDATE: {
      return {
        ...state,
        goalText: action.value
      };
    }

    case actions.GOAL_CREATE_SUCCESS: {
      return {
        ...state,
        goalText: '',
        isInputVisible: false
      };
    }

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/goals/goalAdding/reducer.js
 **/